import {
  AccountCircle,
  ChevronLeft,
  ChevronRight,
  Email,
  Facebook,
  LinkedIn,
  SelectAll,
  Twitter,
} from "@mui/icons-material";
import {
  Box,
  Button,
  ButtonGroup,
  Container,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Drawer,
  FormControl,
  FormHelperText,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  styled,
  SwipeableDrawer,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  useTheme,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getDevSocials,
  addDevSocial,
  getDevSocial,
  updateDevSocial,
  deleteDevSocial,
} from "../../features/Dev/socialSlice";

const Socials = () => {
  const [addSocialLogs, setAddSocialLogs] = useState({
    handle: "",
    profile_url: "",
  });

  const [editSocialLogs, setEditSocialLogs] = useState({
    id: "",
    handle: "",
    profile_url: "",
  });

  const [addSocialDrawer, setAddSocialDrawer] = useState(false);
  const [editSocialDrawer, setEditSocialDrawer] = useState(false);

  const { socials, social } = useSelector((state) => state.social);

  const dispatch = useDispatch();
  const theme = useTheme();

  useEffect(() => {
    dispatch(getDevSocials());
  }, []);

  const toggleAddSocialDrawer = () => {
    setAddSocialDrawer(!addSocialDrawer);
  };

  const toggleEditSocialDrawer = () => {
    setEditSocialDrawer(!editSocialDrawer);
    setEditSocialLogs((log) => ({
      ...log,
      id: social?.id,
      handle: social?.attributes?.handle,
      profile_url: social?.attributes?.profile_url,
    }));
  };

  const handleAddSocialChange = (e) => {
    setAddSocialLogs((socials) => ({
      ...socials,
      [e.target.name]: e.target.value,
    }));
  };

  const handleEditSocialChange = (e) => {
    setEditSocialLogs((socials) => ({
      ...socials,
      [e.target.name]: e.target.value,
    }));
  };

  const handleAddSocialSubmit = (e) => {
    e.preventDefault();
    dispatch(addDevSocial(addSocialLogs));
    dispatch(getDevSocials());
  };

  const handleOpenEdit = (id) => {
    setEditSocialDrawer(true);
    dispatch(getDevSocial(id));
  };
  const handleEditSocialSubmit = (e) => {
    e.preventDefault();
    dispatch(updateDevSocial(editSocialLogs));
    dispatch(getDevSocials());
  };

  const handleDeleteSocial = (id) => {
    dispatch(deleteDevSocial(id));
    dispatch(getDevSocials());
  };

  return (
    <>
      <Container
        maxWidth="md"
        sx={{
          justifyContent: "center",
          alignItems: "center",
          display: "flex",
          // height: "80vh",
        }}
      >
        <TableContainer component={Paper} elevation={4}>
          <Table sx={{ minWidth: "100%" }} aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell>Id</TableCell>
                <TableCell align="right">Handle</TableCell>
                <TableCell align="right">Profile Url</TableCell>

                <TableCell align="right">
                  {/* Action{" "} */}
                  <Button
                    variant="outlined"
                    onClick={() => setAddSocialDrawer(true)}
                    //   onClick={handleOpen}
                  >
                    create{" "}
                  </Button>{" "}
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {socials.length > 0 &&
                socials.map((social) => (
                  <TableRow
                    sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                    key={social.id}
                  >
                    <TableCell component="th" scope="row">
                      {social?.id}
                    </TableCell>
                    <TableCell align="right">
                      {social?.attributes?.handle}
                    </TableCell>
                    <TableCell align="right">
                      {social?.attributes?.profile_url}{" "}
                    </TableCell>

                    <TableCell align="right">
                      <ButtonGroup size="large" aria-label="large button group">
                        <Button
                          color="primary"
                          onClick={() => handleOpenEdit(social?.id)}
                        >
                          Edit
                        </Button>
                        <Button
                          onClick={() => handleDeleteSocial(social?.id)}
                          color="error"
                        >
                          Delete
                        </Button>
                      </ButtonGroup>
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Container>

      <SwipeableDrawer
        anchor="bottom"
        open={addSocialDrawer}
        onClose={toggleAddSocialDrawer}
      >
        <Container>
          <DialogTitle>Add Project</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Please fill in all appropraite filds to add a new project
            </DialogContentText>
            <Box component="form" onSubmit={handleAddSocialSubmit}>
              <Paper p={2} elevation={2}>
                <Box sx={{ p: 2 }}>
                  <Box py={2}>
                    <Grid container spacing={2}>
                      <Grid item xs={12} sm={6}>
                        <Box sx={{ display: "flex", alignItems: "flex-end" }}>
                          <FormControl sx={{ m: 1, width: "100%" }}>
                            <InputLabel id="demo-simple-select-helper-label">
                              skill Type
                            </InputLabel>
                            <Select
                              labelId="demo-simple-select-helper-label"
                              id="demo-simple-select-helper"
                              label="Social Media"
                              value={addSocialLogs.handle}
                              onChange={handleAddSocialChange}
                              name="handle"
                              fullWidth
                              autoWidth
                              sx={{ width: "100%" }}
                            >
                              <MenuItem value="">
                                <em>Social Handle</em>
                              </MenuItem>
                              <MenuItem value="linkedIn">LinkedIn</MenuItem>
                              <MenuItem value="twitter">Twitter</MenuItem>
                              <MenuItem value="facebook">Facebook</MenuItem>
                              <MenuItem value="email">Email Address</MenuItem>
                            </Select>
                            <FormHelperText>
                              select socail media handle
                            </FormHelperText>
                          </FormControl>
                        </Box>
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <Box sx={{ display: "flex", alignItems: "flex-end" }}>
                          <AccountCircle
                            sx={{ color: "action.active", mr: 1, my: 0.5 }}
                          />
                          <TextField
                            //   id="input-with-sx"
                            label="social link"
                            variant="standard"
                            name="profile_url"
                            fullWidth
                            type="url"
                            value={addSocialLogs.profile_url}
                            onChange={handleAddSocialChange}
                            // helperText={errors?.github_link}
                          />
                        </Box>
                      </Grid>
                    </Grid>
                  </Box>
                  <Box sx={{ display: "flex", justifyContent: "center" }}>
                    <Button variant="outlined" size="large" type="submit">
                      Add Social Handle
                    </Button>
                  </Box>
                </Box>
              </Paper>
            </Box>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={toggleAddSocialDrawer}
              color="error"
              variant="outlined"
            >
              close
            </Button>
          </DialogActions>
        </Container>
      </SwipeableDrawer>

      <SwipeableDrawer
        anchor="bottom"
        open={editSocialDrawer}
        onClose={toggleEditSocialDrawer}
      >
        <Container>
          <DialogTitle>Add Project</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Please fill in all appropraite filds to add a new project
            </DialogContentText>
            <Box component="form" onSubmit={handleEditSocialSubmit}>
              <Paper p={2} elevation={2}>
                <Box sx={{ p: 2 }}>
                  <Box py={2}>
                    <Grid container spacing={2}>
                      <Grid item xs={12} sm={6}>
                        <Box sx={{ display: "flex", alignItems: "flex-end" }}>
                          <FormControl sx={{ m: 1, width: "100%" }}>
                            <InputLabel id="demo-simple-select-helper-label">
                              skill Type
                            </InputLabel>
                            <Select
                              labelId="demo-simple-select-helper-label"
                              id="demo-simple-select-helper"
                              label="Social Media"
                              value={editSocialLogs.handle}
                              onChange={handleEditSocialChange}
                              name="handle"
                              fullWidth
                              autoWidth
                              sx={{ width: "100%" }}
                            >
                              <MenuItem value="">
                                <em>Social Handle</em>
                              </MenuItem>
                              <MenuItem value="linkedIn">
                                LinkedIn <LinkedIn />{" "}
                              </MenuItem>
                              <MenuItem value="twitter">
                                Twitter <Twitter />{" "}
                              </MenuItem>
                              <MenuItem value="facebook">
                                Facebook <Facebook />{" "}
                              </MenuItem>
                              <MenuItem value="email">
                                Email Address <Email />{" "}
                              </MenuItem>
                            </Select>
                            <FormHelperText>
                              select socail media handle
                            </FormHelperText>
                          </FormControl>
                        </Box>
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <Box sx={{ display: "flex", alignItems: "flex-end" }}>
                          <AccountCircle
                            sx={{ color: "action.active", mr: 1, my: 0.5 }}
                          />
                          <TextField
                            //   id="input-with-sx"
                            label="social link"
                            variant="standard"
                            name="profile_url"
                            fullWidth
                            type="url"
                            value={editSocialLogs.profile_url}
                            onChange={handleEditSocialChange}
                            // helperText={errors?.github_link}
                          />
                        </Box>
                      </Grid>
                    </Grid>
                    <TextField
                      //   id="input-with-sx"
                      name="id"
                      type="hidden"
                      value={editSocialLogs.id}
                      // onChange={handleEditSocialChange}
                      // helperText={errors?.github_link}
                    />
                  </Box>
                  <Box sx={{ display: "flex", justifyContent: "center" }}>
                    <Button variant="outlined" size="large" type="submit">
                      Edit Social Handle
                    </Button>
                  </Box>
                </Box>
              </Paper>
            </Box>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={toggleEditSocialDrawer}
              color="error"
              variant="outlined"
            >
              close
            </Button>
          </DialogActions>
        </Container>
      </SwipeableDrawer>
    </>
  );
};

export default Socials;
